import { CARD_PATH_SEGMENT, PARAMS } from 'common/constants/url-params';
import { buildStoryPathBase, buildStorySegment, getActivePathPrefix } from 'utils/path-prefix';

export const ANY = '*';
export const ROOT = '/';
export const PREVIEW_PAGE = `${ROOT}preview.html`;
export const ERROR_PAGE = `${ROOT}404.html`;
export { CARD_PATH_SEGMENT };

const { STORIES_DOMAIN, STORY_BASE_PATH, STORY_JSON_PATH, STORY_METADATA_PATH } = window;

const pathPrefix = getActivePathPrefix();
const storySegment = buildStorySegment({
	hostname: window.location.hostname,
	storiesDomain: STORIES_DOMAIN,
	storyBasePath: STORY_BASE_PATH,
});

export const STORY_PATH = {
	domain: `/${STORIES_DOMAIN}`,
	base: buildStoryPathBase({ storySegment, pathPrefix }),
	story: `/${STORY_JSON_PATH}`,
	metadata: `/${STORY_METADATA_PATH}`,
};

export const CARD_PATH = `${STORY_PATH.base}/${CARD_PATH_SEGMENT}/:${PARAMS.CARD_ID}/`;

// eslint-disable-next-line no-console
console.info('[path-prefix] STORY_PATH', {
	base: STORY_PATH.base,
	cardPath: CARD_PATH,
	storySegment,
	pathPrefix: pathPrefix || '(none)',
});
